import { SET_WINDOWWIDTH,SET_ROUTEBACK } from "../actions/otherConst";

const state = {
  countPerPageS: 12,
  countPerPage: 5,
  mobileResolution: 992,
  windowWidth: 0,
  routeBack: {
    isBack: false,
    path: ''
  }
}

const getters = {
  countPerPage: state => state.countPerPage,
  countPerPageS: state => state.countPerPageS,
  windowWidth: state => state.windowWidth,
  mobileResolution: state => state.mobileResolution,
  isMobileResolution: state => state.windowWidth <= state.mobileResolution,
  routeBack: state => state.routeBack,
}

const actions = {
  [SET_WINDOWWIDTH]: ({commit }, payload) => {
    commit(SET_WINDOWWIDTH, payload)
  }
}

const mutations = {
  [SET_WINDOWWIDTH]: (state, payload) => {
    state.windowWidth = payload
  },
  [SET_ROUTEBACK]: (state, payload) => {
    state.routeBack = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
